/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  /**
   * View для отображения текущей выбранной валюты.
   */
  app.CurrencySelectStateView = app.View.extend({
    router: null,
    templateId: '#currency-select-state',
    run: function (options) {
      this.listenTo(Backbone, 'change-currency', this.render);
      if (options && options.templateId) {
        this.templateId = options.templateId;
      }
      if (this.templateId) {
        this.template = app.helpers.TemplateHelper.getTemplate(this.templateId);
      }
    },
    render: function () {
      this.$el.html(this.template(app.currentCurrency));
    }
  });
})();

}.call(window));